import { gql } from '@apollo/client'

export const JOURNAL_ETAT_KANBAN_MUTATION = gql`
  mutation JournalEtatKanban(
    $demandeId: bigint!
    $datesortie: timestamptz! # now()
    $dateentree: timestamptz! # now()
    $dateexpiration: date # now() + etatkanbans.dureeexpirationpardefaut
    $numeroentreejournal: bigint!
    $etatkanbanId: bigint!
  ) {
    update_d4_journaletatkanban(
      _set: { datesortie: $datesortie }
      where: { _and: [{ demande_id: { _eq: $demandeId } }, { datesortie: { _is_null: true } }] }
    ) {
      affected_rows
    }
    jek: insert_d4_journaletatkanban_one(
      object: {
        demande_id: $demandeId
        dateentree: $dateentree
        dateexpiration: $dateexpiration
        numeroentreejournal: $numeroentreejournal
        etatkanban_id: $etatkanbanId
      }
    ) {
      id
      etatkanban {
        id
        libelle
        couleuretatkanban
        kanban {
          id
          titre
        }
      }
    }
  }
`
